export default function DeleteCourses(){
    return <h1>Delete Courses</h1>
}